import validator from "validator";
import { IErrorsState, IErrorValidatorStatus, ISetNewPassword } from "./Access/Interfaces";

// Validates login fields and returns error message
export const validateLoginFields = (captcha: string, email: string, showCaptcha: boolean, password?: string) => {
  let errors: IErrorsState = {};
  let errorStatus: IErrorValidatorStatus = {
    status: true,
    message: "",
    errors,
  };
  if (validator.isEmpty(email)) {
    errors.email = true;
  } else if (!validator.isEmail(email)) {
    errorStatus.status = false;
    errors.email = "Invalid email address";
    errorStatus.message = "Please enter valid email address";
  }
  if (password === "") {
    errors.password = true;
  }
  if (!errors.email && !errors.password && captcha === "" && showCaptcha) {
    errorStatus.status = false;
    errorStatus.message = "Please resolve captcha";
    errors.captcha = true;
  }
  if (errors.email || errors.password) {
    errorStatus.status = false;
    errorStatus.message = "There was an error logging you in";
  }
  errorStatus.errors = errors;
  return errorStatus;
};

//formats login data for requests
export const formatLoginData = (email: string, password: string, isLogin: boolean) => {
  var formData = new FormData();
  if (isLogin) {
    formData.append("username", email);
    formData.append("appName", "workbench-s");
    formData.append("password", password);
  } else {
    formData.append("appName", "workbench-s");
    formData.append("email", email);
    formData.append("recaptcha", password);
  }
  return formData;
};

export const validateEmailField = (captcha: string, email: string) => {
  let errors: IErrorsState = {};
  let errorStatus: IErrorValidatorStatus = {
    status: true,
    message: "",
    errors,
  };
  if (validator.isEmpty(email)) {
    errors.email = true;
    errorStatus.status = false;
    errorStatus.message = "Please enter email";
  } else if (!validator.isEmail(email)) {
    errorStatus.status = false;
    errorStatus.message = "Please enter valid email address";
  }
  if (!errors.email && captcha === "") {
    errorStatus.status = false;
    errorStatus.message = "Please resolve captcha";
    errors.captcha = true;
  }
  errorStatus.errors = errors;
  return errorStatus;
};

export const validateSetNewPasswordFields = (password: string, password2: string) => {
  let errors: ISetNewPassword = {};
  let errorStatus: IErrorValidatorStatus = {
    status: false,
    message: "",
    errors,
  };
  if (validator.isEmpty(password)) {
    errors.password = true;
    errorStatus.status = true;
    errorStatus.message = "Please enter password";
  }
  if (validator.isEmpty(password2)) {
    errors.password2 = true;
    errorStatus.status = true;
    errorStatus.message = "Please enter password";
  }
  if (!validator.isEmpty(password) && !validator.isEmpty(password2)) {
    if (password !== password2) {
      errorStatus.status = true;
      errorStatus.message = "Password doesn't match";
    }
  } else if (validator.isEmpty(password) && validator.isEmpty(password2)) {
    errorStatus.status = true;
    errorStatus.message = "please enter valid passwords";
  } else if (!validator.isLength(password, { min: 6, max: 20 })) {
    errors.password = true;
    errorStatus.message = "length must be between 6 and 20";
  } else if (!validator.isLength(password2, { min: 6, max: 20 })) {
    errors.password2 = true;
    errorStatus.message = "length must be between 6 and 20";
  }

  errorStatus.errors = errors;
  return errorStatus;
};
